import type { AlertUI } from '../../ringcentral-widgets/modules/AlertUI';
import type { Beforeunload } from '../../ringcentral-widgets/modules/Beforeunload';
import type { Block } from '../../ringcentral-widgets/modules/Block';
import type { BlockUI } from '../../ringcentral-widgets/modules/BlockUI';
import type { ConnectivityBadgeUI } from '../../ringcentral-widgets/modules/ConnectivityBadgeUI';
import type { ConnectivityManager } from '../../ringcentral-widgets/modules/ConnectivityManager';
import type { LoginUI } from '../../ringcentral-widgets/modules/LoginUI';
import type { ModalUI } from '../../ringcentral-widgets/modules/ModalUI';
import type { ProxyFrameOAuth } from '../../ringcentral-widgets/modules/ProxyFrameOAuth';
import type { RegionSettingsUI } from '../../ringcentral-widgets/modules/RegionSettingsUI';
import type { RouterInteraction } from '../../ringcentral-widgets/modules/RouterInteraction';
import type { SettingsUI } from '../../ringcentral-widgets/modules/SettingsUI';
import type { AccountInfo } from '../modules/AccountInfo';
import type { Alert } from '../modules/Alert';
import type { AppFeatures } from '../modules/AppFeatures';
import type { Auth } from '../modules/Auth';
import type { AvailabilityMonitor } from '../modules/AvailabilityMonitor';
import type { Brand } from '../modules/Brand';
import type { Call } from '../modules/Call';
import type { CallMonitor } from '../modules/CallMonitor';
import type { ConnectivityMonitor } from '../modules/ConnectivityMonitor';
import type { DateTimeFormat } from '../modules/DateTimeFormat';
import type { DialingPlan } from '../modules/DialingPlan';
import type { Environment } from '../modules/Environment';
import type { ExtensionFeatures } from '../modules/ExtensionFeatures';
import type { ExtensionInfo } from '../modules/ExtensionInfo';
import type { GlobalStorage } from '../modules/GlobalStorage';
import type { Locale } from '../modules/Locale';
import type { Presence } from '../modules/Presence';
import type { RateLimiter } from '../modules/RateLimiter';
import type { RegionSettings } from '../modules/RegionSettings';
import type { Storage } from '../modules/Storage';
import type { Subscription } from '../modules/Subscription';
import type { TabManager } from '../modules/TabManager';

export interface BasePhone {
  alert: Alert;
  auth: Auth;
  block: Block;
  brand: Brand;
  accountInfo: AccountInfo;
  connectivityMonitor: ConnectivityMonitor;
  dateTimeFormat: DateTimeFormat;
  dialingPlan: DialingPlan;
  extensionInfo: ExtensionInfo;
  environment: Environment;
  globalStorage: GlobalStorage;
  locale: Locale;
  extensionFeatures: ExtensionFeatures;
  appFeatures: AppFeatures;
  regionSettings: RegionSettings;
  rateLimiter: RateLimiter;
  subscription: Subscription;
  storage: Storage;
  availabilityMonitor: AvailabilityMonitor;
  oAuth: ProxyFrameOAuth;
  routerInteraction: RouterInteraction;
  callMonitor: CallMonitor;
  connectivityManager: ConnectivityManager;
  settingsUI: SettingsUI;
  connectivityBadgeUI: ConnectivityBadgeUI;
  loginUI: LoginUI;
  alertUI: AlertUI;
  regionSettingsUI: RegionSettingsUI;
  modalUI: ModalUI;
  blockUI: BlockUI;
  tabManager?: TabManager;
  beforeunload: Beforeunload;
  call: Call;
  presence: Presence;
}
